// components/PaiementModal.jsx
import React, { useEffect } from "react";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "10px",
    textAlign: "center",
    width: "40%",
    height: "80%",
    padding: "0",
  },
};

const PaiementModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    Modal.setAppElement("body"); 
  }, []);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles}>
      <button onClick={onClose}>Fermer</button>
<img
  src="/img/tarif.jpg"
  alt="Paiement Information"
  style={{
    width: "100%", 
  }}
/>

    </Modal>
  );
};

export default PaiementModal;
